import request from '@/utils/request'
const itemApi = {
  queryItemList: (params) => {
    return request({
      url: '/item/list',
      method: 'get',
      params
    })
  }
}

export default itemApi
